<template>
    <AppLayout>
        <div class="bg-white">
            <div class="pt-6">
                <nav aria-label="Breadcrumb">
                    <ol role="list"
                        class="mx-auto flex max-w-2xl items-center space-x-2 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                        <li v-for="breadcrumb in page.breadcrumbs" :key="breadcrumb.id">
                            <div class="flex items-center">
                                <a :href="breadcrumb.href" class="mr-2 text-sm font-medium text-slate-900">{{
                                    breadcrumb.name
                                    }}</a>
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="currentColor" aria-hidden="true"
                                    class="h-5 w-4 text-slate-300">
                                    <path d="M5.697 4.34L8.98 16.532h1.327L7.025 4.341H5.697z" />
                                </svg>
                            </div>
                        </li>
                        <li class="text-sm">
                            <a href="#" aria-current="page" class="font-medium text-slate-500 hover:text-slate-600">{{
                                page.name }}</a>
                        </li>
                    </ol>
                </nav>

                <!-- page info -->
                <div class="mx-auto max-w-2xl px-4 pt-10 pb-16 sm:px-6 lg:max-w-7xl lg:px-8 lg:pt-16 lg:pb-24">
                    <div class="lg:col-span-2 lg:border-r lg:border-slate-200 lg:pr-8">
                        <h1 class="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">{{ page.name }}</h1>
                    </div>

                    <div v-for="book in books" class="mt-6" :key="book.id">
                        <div class="grid items-start grid-cols-1 lg:grid-cols-2">
                            <div class="col-span-1 grid grid-cols-1 lg:sticky top-0 gap-0.5">

                                <div class="overflow-hidden">
                                    <img :src="book.thumbnail" alt="Product"
                                        class="w-full aspect-[3/4] object-cover object-top shadow-md hover:scale-[1.05] transition-all duration-300" />
                                </div>
                            </div>

                            <div class="py-6 px-8 max-lg:max-w-2xl">
                                <div>
                                    <h2 class="text-xl font-semibold text-slate-900">{{ book.title }}</h2>
                                    <p class="mt-2 text-sm text-slate-600">{{ book.description }}</p>
                                </div>

                                <div class="mt-8">
                                    <div class="flex items-center flex-wrap gap-4">
                                        <p class="text-slate-900 text-4xl font-semibold">${{ book.price }}</p>
                                    </div>
                                </div>

                                <div class="mt-8 space-y-4">
                                    <Button
                                        class="w-full bg-secondary-600 text-white hover:bg-secondary-700 focus:ring-secondary-500 focus:ring-offset-secondary-200 font-semibold rounded-lg text-sm px-5 py-2.5 text-center"
                                        @click="() => $router.push({ name: 'books.checkout', params: { id: book.id } })">
                                        Buy Now
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-html="books ? books.content : '...'"
                        class="py-10 lg:col-span-2 lg:col-start-1 lg:border-r lg:border-slate-200 lg:pt-6 lg:pr-8 lg:pb-16">
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import { ref } from 'vue';
import { getBooks } from '@/services/bookService.js';
import Button from 'primevue/button';

const books = ref(null);

const fetchBooks = async () => {
    const response = await getBooks();
    books.value = response.data;
}

fetchBooks();

const page = {
    name: 'Books',
    breadcrumbs: [
        { id: 1, name: 'Home', href: '/' },
    ],
    images: [
        {
            src: '/images/courses/quran.jpg',
            alt: 'Page image 1',
        },
        {
            src: '/images/courses/quran.jpg',
            alt: 'Page image 2',
        },
    ],
}
</script>